export default "__VITE_ASSET__B2_G5hHr__"